"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = shouldComponentUpdate;

var _shallowReflectiveEqual = _interopRequireDefault(require("./shallowReflectiveEqual"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function shouldComponentUpdate( // Different versions of flow have different types for React components.
// Using `any` to cover all of them, and just assume that a valid component
component
/*: any*/
, nextProps
/*: {}*/
, nextState
/*: {}*/
)
/*: boolean*/
{
  return !(0, _shallowReflectiveEqual.default)(component.props, nextProps) || !(0, _shallowReflectiveEqual.default)(component.state, nextState);
}